import { render, staticRenderFns } from "./NotificationsDrawer.vue?vue&type=template&id=740f1f6c&scoped=true"
import script from "./NotificationsDrawer.vue?vue&type=script&lang=js"
export * from "./NotificationsDrawer.vue?vue&type=script&lang=js"
import style0 from "./NotificationsDrawer.vue?vue&type=style&index=0&id=740f1f6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740f1f6c",
  null
  
)

export default component.exports